import * as React from 'react'
import { connect } from 'react-redux'
import { ReduxState } from 'src/store/reducers'
import Maintenance from '../routes/maintenance'
import { mainApi } from '../../config'

type Props = {
  route: {
    path: string
  }
  orgId: string
  isNewHomePage: boolean
}

const isDevStage =
  window.location.href.indexOf('localhost') !== -1 ||
  window.location.href.indexOf(':3000') !== -1 ||
  window.location.href.indexOf('tt-react-dev') !== -1 ||
  window.location.href.indexOf('tt-react-test') !== -1 ||
  window.location.href.indexOf('tt-react-qa') !== -1 ||
  window.location.href.indexOf('.cloudfront.net') !== -1 ||
  window.location.href.indexOf('.dev.trainingtube.com') !== -1

const { maintenance } = mainApi(isDevStage)

class Loader extends React.PureComponent<Props, any> {
  state = {
    compnent: null
  }

  async componentDidMount() {
    let Component = null

    if (maintenance) {
      switch (this.props.route.path) {
        case '/login':
          Component = (await import('../routes/login/Login')).default
          break

        case '/auto-login':
          Component = (await import('../routes/auto-login/AutoLogin')).default
          break

        case '/login-lp':
          Component = (await import('../routes/login/LoginLP')).default
          break

        case '/loginembed':
          Component = (await import('../routes/login/LoginEmbed')).default
          break

        case '/register':
          Component = (await import('../routes/register/Register')).default
          break

        case '/reset-password':
          Component = (await import('../routes/reset-password/resetPassword')).default
          break

        case '/forgot-password':
          Component = (await import('../routes/forgot-password/forgotPassword')).default
          break

        default:
          Component = Maintenance
          break
      }
      this.setState({ compnent: Component })
      return
    }

    switch (this.props.route.path) {
      case '/login':
        Component = (await import('../routes/login/Login')).default
        break

      case '/auto-login':
        Component = (await import('../routes/auto-login/AutoLogin')).default
        break

      case '/login-lp':
        Component = (await import('../routes/login/LoginLP')).default
        break

      case '/loginembed':
        Component = (await import('../routes/login/LoginEmbed')).default
        break

      case '/register':
        Component = (await import('../routes/register/Register')).default
        break

      case '/reset-password':
        Component = (await import('../routes/reset-password/resetPassword')).default
        break

      case '/forgot-password':
        Component = (await import('../routes/forgot-password/forgotPassword')).default
        break

      case '/admin/branding':
        Component = (await import('../routes/admin/branding')).default
        break
      case '/admin/organization':
        Component = (await import('../routes/admin/organization')).default
        break

      case '/admin/security':
        Component = (await import('../routes/admin/security')).default
        break

      case '/admin/azure-ad':
        Component = (await import('../routes/admin/ssoConfig/AdminSsoConfig')).default
        break

      case '/admin/videos':
        Component = (await import('../routes/home')).default
        break
      case '/admin/channels':
        Component = (await import('../routes/admin/channels')).default
        break

      case '/subscriptions':
        Component = (await import('../routes/subscriptions')).default
        break

      case '/history':
        Component = (await import('../routes/history')).default
        break

      case '/about/architectural-objects':
        Component = (await import('../routes/data-inventory')).default
        break

      case '/tasks':
        Component = (await import('../routes/tasks')).default
        break

      case '/ai-chat/:taskId':
        Component = (await import('../routes/ai-chat')).default
        break

      case '/results':
        Component = (await import('../routes/searchResults')).default
        break

      case '/orgs/usage':
        Component = (await import('../routes/orgsUsageList')).default
        break
      case '/orgs/crm':
        Component = (await import('../routes/orgsUserCrm')).default
        break
      case '/orgs':
        Component = (await import('../routes/orgsList')).default
        break

      case '/admin/users/usage':
        Component = (await import('../routes/admin/usersUsage')).default
        break

      case '/admin/tracks':
      case '/admin/playlists':
        Component = (await import('../routes/admin/tracks')).default
        break

      case '/admin/tasks':
        Component = (await import('../routes/admin/tasks')).default
        break

      case '/admin/operationalTasks':
        Component = (await import('../routes/admin/operationalTasks')).default
        break

      case '/admin/users':
        Component = (await import('../routes/admin/users')).default
        break

      case '/admin/tags':
        Component = (await import('../routes/admin/tags')).default
        break

      case '/admin/lanes':
        Component = (await import('../routes/admin/lanes')).default
        break
      case '/admin/pools':
        Component = (await import('../routes/admin/pools')).default
        break
      case '/admin/application-roles':
        Component = (await import('../routes/admin/applicationRoles')).default
        break
      case '/admin/application-ids':
        Component = (await import('../routes/admin/applicationIds')).default
        break
      case '/admin/organizations':
        Component = (await import('../routes/admin/organizations')).default
        break
      case '/admin/processes':
        Component = (await import('../routes/admin/processes')).default
        break

      case '/admin/programs':
        Component = (await import('../routes/admin/programs')).default
        break

      case '/admin/projects':
        Component = (await import('../routes/admin/projects')).default
        break

      case '/admin/prompts':
        Component = (await import('../routes/admin/prompts')).default
        break

      case '/admin/data-domains':
        Component = (await import('../routes/admin/data-domains')).default
        break

      case '/admin/datasets':
        Component = (await import('../routes/admin/datasets')).default
        break

      case '/admin/specifications':
        Component = (await import('../routes/admin/specifications')).default
        break

      case '/admin/process-types':
        Component = (await import('../routes/admin/process-types')).default
        break

      case '/admin/it-components':
        Component = (await import('../routes/admin/it-components')).default
        break

      case '/admin/it-interfaces':
        Component = (await import('../routes/admin/it-interfaces')).default
        break

      case '/admin/business-capabilities':
        Component = (await import('../routes/admin/business-capabilities')).default
        break

      case '/admin/user-groups':
        Component = (await import('../routes/admin/user-groups')).default
        break

      case '/admin/risks':
        Component = (await import('../routes/admin/risks')).default
        break

      case '/admin/controls':
        Component = (await import('../routes/admin/controls')).default
        break

      case '/admin/regulations':
        Component = (await import('../routes/admin/regulations')).default
        break

      case '/admin/it-systems':
        Component = (await import('../routes/admin/it-systems')).default
        break

      case '/admin/apis':
        Component = (await import('../routes/admin/apis')).default
        break

      case '/admin/threats':
        Component = (await import('../routes/admin/threats')).default
        break

      case '/admin/vulnerabilities':
        Component = (await import('../routes/admin/vulnerabilities')).default
        break

      case '/admin/data-classifications':
        Component = (await import('../routes/admin/data-classifications')).default
        break

      case '/admin/incident-types':
        Component = (await import('../routes/admin/incident-types')).default
        break

      case '/admin/compliance-frameworks':
        Component = (await import('../routes/admin/compliance-frameworks')).default
        break

      case '/admin/departments':
        Component = (await import('../routes/admin/departments')).default
        break

      case '/admin/hazard-types':
        Component = (await import('../routes/admin/hazard-types')).default
        break

      case '/admin/ppe-types':
        Component = (await import('../routes/admin/ppe-types')).default
        break

      case '/admin/permit-types':
        Component = (await import('../routes/admin/permit-types')).default
        break

      case '/admin/location-types':
        Component = (await import('../routes/admin/location-types')).default
        break

      case '/admin/risk-types':
        Component = (await import('../routes/admin/risk-types')).default
        break

      case '/admin/control-types':
        Component = (await import('../routes/admin/control-types')).default
        break

      case '/admin/equipment-types':
        Component = (await import('../routes/admin/equipment-types')).default
        break

      case '/admin/regulation-types':
        Component = (await import('../routes/admin/regulation-types')).default
        break

      case '/admin/competencies':
        Component = (await import('../routes/admin/competencies')).default
        break

      case '/admin/certificate-types':
        Component = (await import('../routes/admin/certificate-types')).default
        break

      case '/admin/change-types':
        Component = (await import('../routes/admin/change-types')).default
        break

      case '/admin/cost-centers':
        Component = (await import('../routes/admin/cost-centers')).default
        break

      case '/admin/budget-types':
        Component = (await import('../routes/admin/budget-types')).default
        break

      case '/admin/project-types':
        Component = (await import('../routes/admin/project-types')).default
        break

      case '/admin/phase-types':
        Component = (await import('../routes/admin/phase-types')).default
        break

      case '/admin/deliverable-types':
        Component = (await import('../routes/admin/deliverable-types')).default
        break

      case '/admin/time-units':
        Component = (await import('../routes/admin/time-units')).default
        break

      case '/admin/impact-levels':
        Component = (await import('../routes/admin/impact-levels')).default
        break

      case '/admin/change-windows':
        Component = (await import('../routes/admin/change-windows')).default
        break

      case '/admin/rollback-types':
        Component = (await import('../routes/admin/rollback-types')).default
        break

      case '/admin/test-types':
        Component = (await import('../routes/admin/test-types')).default
        break

      case '/admin/environments':
        Component = (await import('../routes/admin/environments')).default
        break

      case '/admin/status-types':
        Component = (await import('../routes/admin/status-types')).default
        break

      case '/admin/license-types':
        Component = (await import('../routes/admin/license-types')).default
        break

      case '/admin/service-level-types':
        Component = (await import('../routes/admin/service-level-types')).default
        break

      case '/admin/escalation-types':
        Component = (await import('../routes/admin/escalation-types')).default
        break

      case '/admin/ai-model-types':
        Component = (await import('../routes/admin/ai-model-types')).default
        break

      case '/admin/evaluation-types':
        Component = (await import('../routes/admin/evaluation-types')).default
        break

      case '/admin/ai-risk-levels':
        Component = (await import('../routes/admin/ai-risk-levels')).default
        break

      case '/admin/human-oversight-types':
        Component = (await import('../routes/admin/human-oversight-types')).default
        break

      case '/admin/quality-standards':
        Component = (await import('../routes/admin/quality-standards')).default
        break

      case '/admin/non-conformance-types':
        Component = (await import('../routes/admin/non-conformance-types')).default
        break

      case '/admin/prompt-types':
        Component = (await import('../routes/admin/prompt-types')).default
        break

      case '/admin/data-fields':
        Component = (await import('../routes/admin/data-fields')).default
        break

      case '/admin/api-endpoints':
        Component = (await import('../routes/admin/api-endpoints')).default
        break

      case '/admin/api-commands':
        Component = (await import('../routes/admin/api-commands')).default
        break

      case '/admin/templates':
        Component = (await import('../routes/admin/templates')).default
        break

      case '/admin/equipments':
        Component = (await import('../routes/admin/equipments')).default
        break

      case '/admin/locations':
        Component = (await import('../routes/admin/locations')).default

        break
      case '/admin/dataobjects':
        Component = (await import('../routes/admin/dataobjects')).default
        break
      case '/admin/llms':
        Component = (await import('../routes/admin/llms')).default
        break

      case '/admin/vendors':
        Component = (await import('../routes/admin/vendors')).default
        break
      case '/admin/decisionRules':
        Component = (await import('../routes/admin/decisionRules')).default
        break
      case '/admin/policies':
        Component = (await import('../routes/admin/policies')).default
        break
      case '/admin/applications':
        Component = (await import('../routes/admin/applications')).default
        break
      case '/admin/application-references':
        Component = (await import('../routes/admin/applicationReferences')).default
        break
      case '/admin/job-roles':
        Component = (await import('../routes/admin/jobRoles')).default
        break
      case '/admin/validationRules':
        Component = (await import('../routes/admin/validationRules')).default
        break

      case '/admin/projects-v2':
        Component = (await import('../routes/admin/projects-v2')).default
        break

      case '/about/why':
        Component = (await import('../routes/admin/why')).default
        break

      case '/about/flipped-classroom':
        Component = (await import('../routes/admin/flipped-classroom')).default
        break

      case '/about/how':
        Component = (await import('../routes/admin/how')).default
        break

      case '/about/what':
        Component = (await import('../routes/admin/what')).default
        break

      case '/about/proof':
        Component = (await import('../routes/admin/proof')).default
        break

      case '/about/hitl':
        Component = (await import('../routes/admin/hitl')).default
        break

      case '/about/roadmap':
        Component = (await import('../routes/admin/roadmap')).default
        break

      case '/about/delivery':
        Component = (await import('../routes/admin/delivery')).default
        break

      case '/about/personas':
        Component = (await import('../routes/admin/personas')).default
        break

      case '/about/comparison':
        Component = (await import('../routes/admin/comparison')).default
        break

      case '/about/business-mining':
        Component = (await import('../routes/admin/business-mining')).default
        break

      case '/about/terminology':
        Component = (await import('../routes/admin/terminology')).default
        break

      case '/admin/flipped-classroom':
        Component = (await import('../routes/admin/flipped-classroom')).default
        break

      case '/about/process-versioning':
        Component = (await import('../routes/admin/process-versioning')).default
        break

      case '/about/ai-factory':
        Component = (await import('../routes/admin/ai-factory')).default
        break

      case '/coo/consulting':
        Component = (await import('../routes/coo/consulting')).default
        break

      case '/coo/consulting/time-log':
        Component = (await import('../routes/coo/consulting/TimeLog')).default
        break

      case '/coo/consulting/invoicing':
        Component = (await import('../routes/coo/consulting/Invoicing')).default
        break

      case '/coo/assistant-search':
        Component = (await import('../routes/coo/assistant-search')).default
        break

      case '/coo/trainingtube-assistance':
        Component = (await import('../routes/coo/trainingtube-assistance')).default
        break

      case '/coo/video-translations':
        Component = (await import('../routes/coo/video-translations')).default
        break

      case '/coo/administration':
        Component = (await import('../routes/coo/COODashboard/index')).default
        break

      case '/admin/training-plans':
        Component = (await import('../routes/admin/trainingPlans')).default
        break
      case '/admin/training-users':
        Component = (await import('../routes/admin/trainingUsers')).default
        break

      case '/admin/reports/shared':
        Component = (await import('../routes/admin/sharedReports')).default
        break

      case '/admin/reports':
        Component = (await import('../routes/admin/reports')).default
        break

      case '/admin/information-classification':
        Component = (await import('../routes/admin/infClassification')).default
        break

      case '/admin/data-flow-diagram':
        Component = (await import('../routes/admin/data-flow-diagram')).default
        break

      case this.props.isNewHomePage === true && '/home':
        Component = (await import('../routes/mandatory/HomePageContainer')).default
        break
      case this.props.isNewHomePage === false && '/home':
        Component = (await import('../routes/home')).default
        break
      case '/mandatory':
        Component = (await import('../routes/mandatory/MandatoryContainer')).default
        break
      // chat-system
      case '/support/chat':
        Component = (await import('../routes/chat')).default
        break

      case '/video/:humanId':
      case '/video/:humanId/:version/:lang':
        Component = (await import('../routes/video/home')).default
        break

      case '/produce-video/:taskId':
      case '/translate-video/:taskId':
        Component = (await import('../routes/video/home/ProduceVideo')).default
        break

      case '/channel/:channelId/home':
        Component = (await import('../routes/channel/home')).default
        break

      case '/channel/:channelId/videos':
        Component = (await import('../routes/channel/videos')).default
        break

      case '/channel/:channelId/tasks':
        Component = (await import('../routes/channel/tasks')).default
        break

      case '/channel/:channelId/wallet':
        Component = (await import('../routes/channel/wallet')).default
        break

      case '/channel/create':
        Component = (await import('../routes/channel/create/ChannelCreate')).default
        break

      case '/channel/edit/:channelId':
        Component = (await import('../routes/channel/edit/overview')).default
        break
      case '/channel/:channelId/event-log':
        Component = (await import('../routes/channel/edit/update-history')).default
        break

      case '/channel/access-control/:channelId':
        Component = (await import('../routes/channel/edit/access-control')).default
        break

      case '/channel/tags/:channelId':
        Component = (await import('../routes/channel/edit/tags')).default
        break

      case '/channel/recommendation/:channelId':
        Component = (await import('../routes/channel/edit/recommendation')).default
        break

      // case '/channel/users/:channelId':
      //   Component = (await import('../routes/channel/edit/users')).default
      //   break

      case '/channel/:channelId/users':
        Component = (await import('../routes/channel/users/ChannelUsers')).default
        break

      case '/channel/:channelId/reports/shared':
        Component = (await import('../routes/channel/sharedReports')).default
        break
      case '/channel/:channelId/reports/training-plan-overview':
        Component = (await import('../routes/channel/reports/training-overview')).default
        break
      case '/channel/:channelId/reports/flowchart-video-overview':
        Component = (await import('../routes/channel/reports/content-overview')).default
        break
      case '/channel/:channelId/reports/user-task-video-overview':
        Component = (await import('../routes/channel/reports/build-overview')).default
        break
      case '/channel/:channelId/reports/training-plan-tasks':
        Component = (await import('../routes/channel/reports/task-list')).default
        break
      case '/channel/:channelId/reports':
        Component = (await import('../routes/channel/reports')).default
        break

      case '/channel/:channelId/tracks':
      case '/channel/:channelId/playlists':
        Component = (await import('../routes/channel/tracks')).default
        break
      case '/channel/:channelId/playlist/:trackId/share':
        Component = (await import('../routes/track/share')).default
        break
      case '/channel/:channelId/playlist/:trackId/create-video':
        Component = (await import('../routes/track/create-video')).default
        break

      case '/channel/:channelId/promotions':
        Component = (await import('../routes/channel/promotions')).default
        break
      case '/playlist/create/:trackId':
        Component = (await import('../routes/track/create')).default
        break
      case '/track/create':
      case '/playlist/create':
        Component = (await import('../routes/track/create')).default
        break

      case '/playlist/edit/:trackId/translations':
        Component = (await import('../routes/track/edit/translations')).default
        break

      case '/playlist/edit/:trackId/share':
        Component = (await import('../routes/track/edit/share')).default
        break
      case '/playlist/edit/:trackId':
      case '/track/edit/:trackId':
        Component = (await import('../routes/track/edit/overview')).default
        break

      case '/track/users/:trackId':
      case '/playlist/users/:trackId':
        Component = (await import('../routes/track/edit/users')).default
        break

      case '/create/video':
        Component = (await import('../routes/video/create/VideoCreate')).default
        break

      case '/edit/video/overview/:videoId/:version/:section':
      case '/edit/video/editor/:videoId/:version/:section/effects':
      case '/edit/video/editor/:videoId/:version/:section/manuscript':
      case '/edit/video/editor/:videoId/:version/:section/quick-guide':
      case '/edit/video/editor/:videoId/:version/:section/links':
      case '/edit/video/ask-for-review/:videoId/:version/:section':
      case '/edit/video/reports/:videoId/:version/:section':
      case '/edit/video/shared/reports/:videoId/:version/:section':
      case '/edit/video/tags/:videoId/:version/:section':
      case '/edit/video/embed-codes/:videoId/:version/:section':
      case '/edit/video/editor/:videoId/:version/:section/upload-files':
      case '/edit/video/editor/:videoId/:version/:section/voice-over':
      case '/edit/video/:videoId/:version/:section/event-log':
        Component = (await import('../routes/video-edit')).default
        break

      case '/edit/video/translator/:videoId/:version/:section/title':
        Component = (await import('../routes/video-edit/translate/VideoTranslate')).default
        break

      case '/edit/video/translator/:videoId/:version/:section/manuscript':
        Component = (await import('../routes/video-edit/translate/VideoManuscript')).default
        break

      case '/edit/video/translator/:videoId/:version/:section/quick-guide':
        Component = (await import('../routes/video-edit/translate/VideoQuickGuide')).default
        break

      case '/edit/video/translator/:videoId/:version/:section/links':
        Component = (await import('../routes/video-edit/translate/VideoLinks')).default
        break

      case '/edit/video/translator/:videoId/:version/:section/caption':
        Component = (await import('../routes/video-edit/translate/VideoCaptions')).default
        break

      case '/edit/video/translator/:videoId/:version/:section/voice-annotation':
        Component = (await import('../routes/video-edit/translate/VideoVoiceOver')).default
        break

      case '/edit/video/translator/:videoId/:version/:section/effects':
        Component = (await import('../routes/video-edit/translate/VideoEditor')).default
        break

      case '/edit/video/translator/:videoId/:version/:section/upload-files':
        Component = (await import('../routes/video-edit/translate/VideoUploadFile')).default
        break

      case '/channel/:redirectId':
        Component = (await import('../routes/channel/redirect')).default
        break

      // case '/finance/video-rendering':
      //   Component = (await import('../routes/admin/video-rendering')).default
      //   break

      // case '/finance/anonymous-plays':
      //   Component = (await import('../routes/admin/anonymous-plays')).default
      //   break

      // case '/finance/internal-users':
      //   Component = (await import('../routes/admin/internal-users')).default
      //   break

      // case '/finance/external-users':
      //   Component = (await import('../routes/admin/external-users')).default
      //   break

      case '/finance/features-services':
        Component = (await import('../routes/admin/features-services')).default
        break

      case '/approved-task-ledger':
        Component = (await import('../routes/admin/approved-task-ledger')).default
        break

      case '/admin/service-consumption/optimization':
        Component = (await import('../routes/admin/service-consumption/video-optimization')).default
        break

      case '/admin/service-consumption/translation':
        Component = (await import('../routes/admin/service-consumption/video-translation')).default
        break

      case '/admin/service-consumption/processing':
        Component = (await import('../routes/admin/service-consumption/video-processing')).default
        break

      case '/admin/service-consumption/assistance':
        Component = (await import('../routes/admin/service-consumption/platform-assistance')).default
        break

      case '/admin/service-consumption/consulting':
        Component = (await import('../routes/admin/service-consumption/consulting')).default
        break

      case '/admin/service-consumption/feature-usage':
        Component = (await import('../routes/admin/service-consumption/feature-usage')).default
        break

      case '/admin/service-consumption/wallet':
        Component = (await import('../routes/admin/service-consumption/wallet')).default
        break

      case '/admin/service-consumption/wallet-overview':
        Component = (await import('../routes/admin/service-consumption/wallet-overview')).default
        break

      case '/coo/all-orgs-wallet-balance':
        Component = (await import('../routes/admin/service-consumption/all-orgs-wallet-balance')).default
        break

      case '/coo/consumption-ledger':
        Component = (await import('../routes/admin/service-consumption/consumption-ledger')).default
        break

      case '/lp':
        Component = (await import('../routes/sso-login')).default
        break

      default:
        Component = Maintenance
        break
    }

    this.setState({ compnent: Component })
  }

  render() {
    const Component = this.state.compnent
    const isAutoLogin = this.props.route.path === '/auto-login'

    return Component ? (
      <Component {...this.props} />
    ) : isAutoLogin ? (
      <div className="w-100 h-100" style={{ background: '#3C4252' }} />
    ) : null
  }
}

const mapStateToProps = (state: ReduxState) => ({
  orgId: state.auth.organization.id,
  isNewHomePage:
    state.auth.organization.featureFlags.filter((e) => e.featureId === 'new-home-page')[0]?.configuration === 'tube'
})

export default connect(mapStateToProps, null)(Loader)
